import React from 'react';
import { UsMapProps } from './state-type';
import States from './states';
import Labels from './labels';
import { MapContainer, MapSvg } from './styles';

const RiseMap: React.FC<UsMapProps> = ({ selectLocation }) => {
  const onClick = (e: any) => {
    if (selectLocation) {
      const state: string = e.target.id;
      if (state) selectLocation(state);
    }
  };

  return (
    <MapContainer>
      <MapSvg
        width="100%"
        height="100%"
        viewBox="0 0 600 400"
        overflow="visible"
        enableBackground="new 0 0 600 400"
      >
        <rect fill="none" width="600" height="400" />
        <g data-name="Layer 2">
          <g id="United_States" data-name="United States" onClick={onClick}>
            <States />
            <Labels />
            <g id="lines">
              <line fill="none" stroke="#000000" x1="535.375" y1="136.125" x2="543" y2="137.25" />
              <line fill="none" stroke="#000000" x1="539.125" y1="154.25" x2="530.125" y2="155.875" />
              <line fill="none" stroke="#000000" x1="538.125" y1="168.625" x2="512.563" y2="151.313" />
              <line fill="none" stroke="#000000" x1="560.375" y1="117.375" x2="548.125" y2="109.5" />
              <line fill="none" stroke="#000000" x1="571.375" y1="111.625" x2="558.375" y2="104.75" />
              <line fill="none" stroke="#000000" x1="569.75" y1="90.5" x2="556.5" y2="96.625" />
              <line fill="none" stroke="#000000" x1="524.625" y1="56.5" x2="536.875" y2="70" />
              <line fill="none" stroke="#000000" x1="540.5" y1="50.875" x2="552.5" y2="79.5" />
            </g>
          </g>
        </g>
      </MapSvg>
    </MapContainer>
  );
};

export default RiseMap;
